import React from "react";
import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import BasicTree from "./BasicTree";
import CheckboxTree from "./DisabledTree";

const TreeViewContainer = () => {
  return (
    <Container fluid={true}>
      <Breadcrumbs pageTitle="Tree View" parent="Bonus Ui" title="Tree View" />
      <Row>
        <BasicTree />
        <CheckboxTree />
      </Row>
    </Container>
  );
};

export default TreeViewContainer;
